import React from 'react';
import styled from 'styled-components';
import CloseIcon from '../../images/ui/close-x-icon.png';

const CloseBtn = styled.div`
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 60px;
  position: absolute;
  z-index: 9000;
  cursor: pointer;
  top: 6px;
  right: 8px;
`;
const CloseText = styled.span`
  font-size: 12px;
  margin-right: 8px;
`;
const CloseImg = styled.img`
  height: 24px;
  width: 24px;
`;

export default function CloseButton(props) {
  return (
    <CloseBtn onClick={props.close} id={props.id}>
      {props.noText ? '' : <CloseText>CLOSE</CloseText>}{' '}
      <CloseImg src={CloseIcon} alt="Close" />
    </CloseBtn>
  );
}
